import { useCallback as e, useEffect as t, useRef as n, useState as r } from "react";
//#region src/components/FullscreenGallery/hooks/useGalleryZoom.ts
var i = 1, a = 3, o = 2, s = .01, c = (c) => {
	let [l, u] = r({
		scale: 1,
		isZoomed: !1,
		translateX: 0,
		translateY: 0
	}), d = n(!1), f = n({
		x: 0,
		y: 0
	}), p = n({
		x: 0,
		y: 0
	}), m = n(0);
	t(() => {
		u({
			scale: 1,
			isZoomed: !1,
			translateX: 0,
			translateY: 0
		});
	}, [c]);
	let h = e((e, t, n) => {
		if (n <= 1) return {
			x: 0,
			y: 0
		};
		let r = (n - 1) / n * 50;
		return {
			x: Math.max(-r, Math.min(r, e)),
			y: Math.max(-r, Math.min(r, t))
		};
	}, []), g = e((e) => {
		if (d.current) return;
		let t = e.currentTarget.getBoundingClientRect(), n = e.clientX, r = e.clientY;
		u((e) => {
			if (e.isZoomed) return {
				scale: 1,
				isZoomed: !1,
				translateX: 0,
				translateY: 0
			};
			let i = ((n - t.left) / t.width - .5) * 100, a = ((r - t.top) / t.height - .5) * 100, s = h(-i, -a, o);
			return {
				scale: o,
				isZoomed: !0,
				translateX: s.x,
				translateY: s.y
			};
		});
	}, [h]), _ = e((e) => {
		e.preventDefault(), u((t) => {
			let n = Math.max(i, Math.min(a, t.scale - e.deltaY * .002)), r = n > 1.05;
			if (!r) return {
				scale: 1,
				isZoomed: !1,
				translateX: 0,
				translateY: 0
			};
			let o = h(t.translateX, t.translateY, n);
			return {
				scale: n,
				isZoomed: r,
				translateX: o.x,
				translateY: o.y
			};
		});
	}, [h]), v = n(!1), y = e((e) => {
		l.isZoomed && (e.preventDefault(), d.current = !0, v.current = !1, f.current = {
			x: e.clientX,
			y: e.clientY
		}, p.current = {
			x: l.translateX,
			y: l.translateY
		});
	}, [
		l.isZoomed,
		l.translateX,
		l.translateY
	]), b = e((e) => {
		if (!d.current) return;
		let t = (e.clientX - f.current.x) / l.scale, n = (e.clientY - f.current.y) / l.scale;
		(Math.abs(t) > 3 || Math.abs(n) > 3) && (v.current = !0);
		let r = h(p.current.x + t * (100 / window.innerWidth) * 2, p.current.y + n * (100 / window.innerHeight) * 2, l.scale);
		u((e) => ({
			...e,
			translateX: r.x,
			translateY: r.y
		}));
	}, [l.scale, h]), x = e(() => {
		v.current ? requestAnimationFrame(() => {
			d.current = !1;
		}) : d.current = !1;
	}, []), S = e(() => {
		d.current = !1;
	}, []), C = (e) => {
		if (e.length < 2) return 0;
		let t = e[0].clientX - e[1].clientX, n = e[0].clientY - e[1].clientY;
		return Math.sqrt(t * t + n * n);
	};
	return {
		zoom: l,
		zoomHandlers: {
			onClick: g,
			onWheel: _,
			onTouchStart: e((e) => {
				e.touches.length === 2 ? m.current = C(e.touches) : e.touches.length === 1 && l.isZoomed && (d.current = !0, f.current = {
					x: e.touches[0].clientX,
					y: e.touches[0].clientY
				}, p.current = {
					x: l.translateX,
					y: l.translateY
				});
			}, [
				l.isZoomed,
				l.translateX,
				l.translateY
			]),
			onTouchMove: e((e) => {
				if (e.touches.length === 2) {
					let t = C(e.touches), n = t - m.current;
					m.current = t, u((e) => {
						let t = Math.max(i, Math.min(a, e.scale + n * s)), r = t > 1.05;
						if (!r) return {
							scale: 1,
							isZoomed: !1,
							translateX: 0,
							translateY: 0
						};
						let o = h(e.translateX, e.translateY, t);
						return {
							scale: t,
							isZoomed: r,
							translateX: o.x,
							translateY: o.y
						};
					});
				} else if (e.touches.length === 1 && d.current) {
					let t = (e.touches[0].clientX - f.current.x) / l.scale, n = (e.touches[0].clientY - f.current.y) / l.scale, r = h(p.current.x + t * (100 / window.innerWidth) * 2, p.current.y + n * (100 / window.innerHeight) * 2, l.scale);
					u((e) => ({
						...e,
						translateX: r.x,
						translateY: r.y
					}));
				}
			}, [l.scale, h]),
			onTouchEnd: e(() => {
				d.current = !1, m.current = 0;
			}, []),
			onMouseDown: y,
			onMouseMove: b,
			onMouseUp: x,
			onMouseLeave: S
		}
	};
};
//#endregion
export { c as useGalleryZoom };
